export default __webpack_public_path__ + "static/media/green-tick.2f2b5ae3.svg";